module.exports = __webpack_public_path__ + "img/645.e7371e6b.jpg";